var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSynchronizeArrowsSearch = function SvgSynchronizeArrowsSearch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4998 45.4924L35.2278 34.2204",
    stroke: "#ABB5BB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5462 36.4937C9.32359 34.3561 6.87508 31.2374 5.5633 27.5995C4.25152 23.9616 4.14622 19.998 5.263 16.2956C6.37978 12.5932 8.65925 9.34893 11.7638 7.04318C14.8684 4.73744 18.6331 3.49286 22.5002 3.49374",
    stroke: "#DDE2E4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.546 25.4473V36.4933H1.5",
    stroke: "#DDE2E4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.454 6.49475C35.6766 8.6324 38.1251 11.7511 39.4369 15.389C40.7487 19.0269 40.854 22.9905 39.7372 26.6929C38.6204 30.3953 36.341 33.6396 33.2364 35.9453C30.1318 38.2511 26.3672 39.4956 22.5 39.4948",
    stroke: "#ABB5BB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4539 17.5417V6.49374H43.4999",
    stroke: "#ABB5BB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSynchronizeArrowsSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/synchronize-arrows-search.613e7544.svg";
export { ForwardRef as ReactComponent };